<!-- Historical games from admin-->
<template>
  <div class="slide sidearm-mm-game-recap relative">
    <div
      :style="{
        backgroundImage:
          game.story && game.story.image
            ? `url(${$root.absolutize_cdn(game.story.image.url)})`
            : 'none'
      }"
      class="sidearm-mm-game-recap__background sidearm-mm-game-recap__slide-in bg-black bg-size-cover col-6-of-8"
    >
      <div
        class="sidearm-mm-game-recap__divider sidearm-mm-game-recap__divider--start absolute"
      >
        <span></span>
      </div>
    </div>
    <div
      class="sidearm-mm-game-recap__content flex flex-align-stretch h-100 w-100 relative"
    >
      <div
        class="sidearm-mm-game-recap__body text-white col-2-of-8 col-push-1 flex flex-column flex-justify-center"
      >
        <h3 class="type-heading-bracket-plain --light mt-0 mb-1">
          Game {{ index.toString().padStart(3, "0") }}
        </h3>
        <h4
          class="type-hero mt-0 mb-4"
          :class="{
            '--long': this.$root.shorten_name(game.opponent.title).length > 13
          }"
        >
          {{ game.location_indicator === "A" ? "at" : "vs." }}
          {{ this.$root.shorten_name(game.opponent.title) }}
        </h4>
        <a
          v-if="game.story && game.story.url"
          :href="game.story.url"
          target="_blank"
          class="sidearm-mm-game-recap__story-link type-paragraph-large ma-0 text-decoration-none"
        >
          Recap: {{ game.story.headline }}
        </a>
      </div>
      <div
        class="sidearm-mm-game-recap__aside col-3-of-8 xx-large-col-2-of-8 xx-large-col-push-1 flex flex-column flex-align-stretch flex-justify-start"
      >
        <div
          v-if="line_scores"
          class="bg-white sidearm-mm-game-recap__linescore"
        >
          <table
            class="sidearm-mm-game-recap__linescore-table text-center type-paragraph-small w-100"
            cellspacing="0"
          >
            <caption class="hide">
              Score by Periods
            </caption>
            <tbody>
              <tr>
                <th scope="row" class="text-normal">
                  <div
                    :class="{
                      'sidearm-mm-game-recap__linescore-winner':
                        line_scores.game_winner !== 'H'
                    }"
                    class="flex flex-align-center"
                  >
                    <img
                      :src="
                        `${
                          line_scores.period_away_score[
                            line_scores.period_away_score.length - 1
                          ] === game.result.opponent_score
                            ? $root.absolutize_cdn(game.opponent.image.url)
                            : $root.school_logo()
                        }?width=36&height=36`
                      "
                      class="sidearm-mm-game-recap__linescore-logo pa-1"
                    />
                    <span
                      class="sidearm-mm-game-recap__linescore-team text-left"
                      >{{
                        line_scores.period_away_score[
                          line_scores.period_away_score.length - 1
                        ] === game.result.opponent_score
                          ? this.$root.shorten_name(game.opponent.title)
                          : $root.data.school.name
                      }}</span
                    >
                  </div>
                </th>
                <td
                  v-for="(score, index) in line_scores.period_away_score"
                  :key="index"
                  :class="{
                    'border-light-l text-bold':
                      index === line_scores.period_away_score.length - 1
                  }"
                  class="px-05"
                >
                  {{ score }}
                </td>
              </tr>
              <tr>
                <th scope="row" class="border-light-t text-normal ">
                  <div
                    :class="{
                      'sidearm-mm-game-recap__linescore-winner':
                        line_scores.game_winner === 'H'
                    }"
                    class="flex flex-align-center"
                  >
                    <img
                      :src="
                        `${
                          line_scores.period_away_score[
                            line_scores.period_away_score.length - 1
                          ] != game.result.opponent_score
                            ? $root.absolutize_cdn(game.opponent.image.url)
                            : $root.school_logo()
                        }?width=36&height=36`
                      "
                      class="sidearm-mm-game-recap__linescore-logo pa-1"
                    />
                    <span
                      class="sidearm-mm-game-recap__linescore-team text-left"
                      >{{
                        line_scores.period_away_score[
                          line_scores.period_away_score.length - 1
                        ] != game.result.opponent_score
                          ? this.$root.shorten_name(game.opponent.title)
                          : $root.data.school.name
                      }}</span
                    >
                  </div>
                </th>
                <td
                  v-for="(score, index) in line_scores.period_home_score"
                  :key="index"
                  :class="{
                    'border-light-l text-bold':
                      index === line_scores.period_home_score.length - 1
                  }"
                  class="px-05 border-light-t"
                >
                  {{ score }}
                </td>
              </tr>
            </tbody>
          </table>
        </div>
        <div
          class="sidearm-mm-game-recap__links flex flex-column flex-align-start mt-auto text-white"
        >
          <!--TODO-KL i dont historical games have videos-->
          <div
            v-if="game.story && game.story.video"
            class="flex flex-align-center pb-2"
          >
            <modal-video :video="game.story.video">
              <button
                slot-scope="scope"
                type="button"
                @click="scope.open"
                class="sidearm-mm-play-btn"
                aria-label="Watch Highlight"
              >
                <icon>sf-play-minimal</icon>
              </button>
            </modal-video>
            <div class="type-paragraph mx-1">Related Video</div>
          </div>
          <a
            v-if="game.result.boxscore"
            :href="game.result.boxscore"
            target="_blank"
            class="sidearm-mm-btn --ghost"
            >Box Score</a
          >
        </div>
      </div>
    </div>
    <div
      class="sidearm-mm-game-recap__divider sidearm-mm-game-recap__divider--end col-3-of-8 absolute"
    >
      <span></span>
    </div>
    <background-element
      class="sidearm-mm-game-recap__top-background-element sidearm-mm-game-recap__slide-in col-1-of-8 absolute"
    />
    <background-element
      class="sidearm-mm-game-recap__bottom-background-element sidearm-mm-game-recap__slide-in col-1-of-8 absolute"
    />
  </div>
</template>

<script>
import BackgroundElement from "@/components/Globals/BackgroundElement";

export default {
  name: "SlideGameRecap",
  props: {
    game: { type: Object, required: true },
    index: { type: Number, required: false }
  },

  components: {
    BackgroundElement
  },

  data: () => ({}),

  computed: {
    line_scores() {
      if (this.game && this.game.result.result_json) {
        try {
          return JSON.parse(this.game.result.result_json);
        } catch (e) {
          console.log("Failed to parse linescore json", e);
          return null;
        }
      }
      return null;
    }
  }
};
</script>
<style lang="scss" scoped>
.sidearm-mm-game-recap {
  &.active {
    .sidearm-mm-game-recap__slide-in {
      transform: none;
    }
  }
  &__divider {
    top: calc(50% + #{$header-height/2});
    transform: translateY(-50%);
    z-index: 1;
    > span {
      display: inline-block;
      border-radius: 50%;
      border: 1px solid $color-white;
      display: block;
      height: 1.5rem;
      width: 1.5rem;
    }
    &--start {
      top: 50%;
      left: 0;
      padding-left: 36px;
      &::before {
        position: absolute;
        top: 50%;
        left: 0;
        width: 36px;
        height: 1px;
        content: "";
        background: $color-white;
      }
    }
    &--end {
      right: 0;
      &::before {
        width: calc(33.3333% - 1.5rem);
        height: 1px;
        position: absolute;
        top: 50%;
        left: 1.5rem;
        content: "";
        background: $color-white;
      }
      &::after {
        width: 100%;
        height: 1px;
        position: absolute;
        top: 50%;
        left: 33.3333%;
        content: "";
        background-color: $color-black;
      }
    }
  }
  &__background {
    position: absolute;
    top: $header-height;
    height: calc(100% - #{$header-height});
    left: 0;
    z-index: 1;
    background-position: top center;
    background-repeat: no-repeat;
    &::after {
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      content: "";
      background: rgba(0, 0, 0, 0.7);
    }
  }
  &__top-background-element {
    top: $header-height;
    left: 0;
    height: calc((100% - #{$header-height}) * 0.375);
    z-index: 1;
  }
  &__bottom-background-element {
    bottom: 0;
    right: 50%;
    height: calc((100% - #{$header-height}) * 0.625);
    z-index: 1;
  }
  &__content {
    z-index: 2;
    padding-top: calc(#{$header-height} + #{grid_percent(60)});
    padding-bottom: #{grid_percent(120)};
  }
  &__linescore {
    padding: #{grid_percent(30)};
    box-shadow: 0px 6px 36px rgba(0, 0, 0, 0.2);
    transform: translateX(#{grid_percent(60)});
    @include flex-item(0 0 auto);
  }
  &__linescore-team {
  }
  &__linescore-winner {
    position: relative;
    &::before {
      position: absolute;
      top: 50%;
      left: 0;
      width: $spacer/2;
      height: $spacer/2;
      border-radius: 50%;
      content: "";
      background: $color-success;
      transform: translateY(-50%);
    }
  }
  &__story-link {
    color: $color-white;
  }
  &__links {
    @include flex-item(0 0 auto);
    height: 50%;
  }
  .sidearm-mm-play-btn {
    @include play-btn(3.75rem);
  }
  &__slide-in {
    transform: translateX(60px);
    transition: transform 0.4s 0.3s;
  }
}
</style>
